import { cn, parseVideoUrl } from '@utils'
import { useSessionStore, useUIStore } from '@stores'
import { VideoProvider } from '@/constants'

interface StaticData {
  image?: { file: string }
  image_tablet?: { file: string }
  image_mobile?: { file: string }
  embed_code?: string
}

interface SessionWithStaticData {
  step_static_data?: StaticData
  [key: string]: any
}

interface StepMediaProps {
  session?: SessionWithStaticData
  className?: string
}

const StepMedia = ({ session: sessionProp, className }: StepMediaProps) => {
  const sessionStore = useSessionStore(state => state.session)
  const isMediaHidden = useUIStore(state => state.isMediaHidden)

  const session = sessionProp || sessionStore
  const staticData = (session as any)?.step_static_data
  const hasMedia = !!(staticData?.image || staticData?.embed_code)

  if (!hasMedia || isMediaHidden) {
    return null
  }

  return (
    <div className={cn('static-data-container', className)}>
      {staticData?.image && (
        <img
          alt="static-image"
          className="static-image hidden lg:inline-block static_image_width"
          src={staticData.image.file}
        />
      )}

      {staticData?.image_tablet && (
        <img
          alt="static-image-tablet"
          className="static-image-tablet hidden lg:hidden md:inline-block static_image_width"
          src={staticData.image_tablet.file}
        />
      )}

      {staticData?.image_mobile && (
        <img
          alt="static-image-mobile"
          className="static-image-mobile md:hidden sm:inline-block static_image_width"
          src={staticData.image_mobile.file}
        />
      )}

      {staticData?.embed_code &&
        (parseVideoUrl(staticData.embed_code)?.provider === VideoProvider.File ? (
          <video src={staticData.embed_code} controls playsInline title="Embedded media content" />
        ) : (
          <iframe src={staticData.embed_code} frameBorder="0" allowFullScreen title="Embedded media content" />
        ))}
    </div>
  )
}

export default StepMedia
